module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    class: {
      english: _vm.$i18n.locale == 'en'
    }
  }, [_c('HeaderLine', {
    ref: "dialog",
    attrs: {
      "index": "12",
      "showbar": "true"
    },
    on: {
      "on-locale-change": _vm.onLocaleChange
    }
  }, [_vm._v("\n      " + _vm._s(_vm.$t('software.name')) + "\n    ")]), _vm._v(" "), _c('div', {
    staticClass: "banner",
    staticStyle: {
      "height": "5rem"
    }
  }, [_c('img', {
    attrs: {
      "src": _vm.imglist[0],
      "alt": ""
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "introduction center"
  }, [_c('ul', {
    staticClass: "download_list main_wrap"
  }, [_c('li', {
    staticClass: "download_list_item"
  }, [_c('h3', {
    staticClass: "download_item_title",
    attrs: {
      "id": "anchor1"
    },
    domProps: {
      "innerHTML": _vm._s(_vm.$t('software.introduction_title'))
    }
  }), _vm._v(" "), _c('h4', {
    staticClass: "download_item_title2",
    staticStyle: {
      "line-height": "1.6em"
    },
    domProps: {
      "innerHTML": _vm._s(_vm.$t('software.introduction_title2'))
    }
  }), _vm._v(" "), _c('ul', {
    staticClass: "download_platforms clearfix platform_pic"
  }, [_c('li', [_c('div', {
    staticClass: "pic_box"
  }, [_c('div', {
    staticClass: "pic_mask2"
  }, [_c('a', {
    staticClass: "button3",
    attrs: {
      "href": "https://a.app.qq.com/o/simple.jsp?pkgname=com.vrviu.lightvr",
      "target": "_blank"
    }
  }, [_vm._v(_vm._s(_vm.$t('software.download')))])]), _vm._v(" "), _c('img', {
    attrs: {
      "src": require("../assets/images/software/icon_cardborad@2x.png"),
      "alt": ""
    }
  })]), _vm._v(" "), _c('h3', {
    staticClass: "platform_name",
    domProps: {
      "innerHTML": _vm._s(_vm.$t('software.product_title1'))
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "platform_info"
  }, [_vm._v(_vm._s(_vm.$t('software.product_vison1')))]), _vm._v(" "), _c('p', {
    staticClass: "platform_info",
    staticStyle: {
      "margin-bottom": "0.35rem"
    }
  }, [_vm._v(_vm._s(_vm.$t('software.product_date1')))])]), _vm._v(" "), _c('li', [_c('div', {
    staticClass: "pic_box"
  }, [_c('div', {
    staticClass: "pic_mask2"
  }, [_c('a', {
    staticClass: "button3",
    attrs: {
      "href": "https://www.vrviu.com/static/download/sdk/LightVR_V2.5_forPico.zip"
    }
  }, [_vm._v(_vm._s(_vm.$t('software.download')))])]), _vm._v(" "), _c('img', {
    attrs: {
      "src": require("../assets/images/software/icon_Pico@2x.png"),
      "alt": ""
    }
  })]), _vm._v(" "), _c('h3', {
    staticClass: "platform_name",
    domProps: {
      "innerHTML": _vm._s(_vm.$t('software.product_title2'))
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "platform_info"
  }, [_vm._v(_vm._s(_vm.$t('software.product_vison2')))]), _vm._v(" "), _c('p', {
    staticClass: "platform_info",
    staticStyle: {
      "margin-bottom": "0.35rem"
    }
  }, [_vm._v(_vm._s(_vm.$t('software.product_date2')))])]), _vm._v(" "), _c('li', [_vm._m(0), _vm._v(" "), _c('h3', {
    staticClass: "platform_name",
    domProps: {
      "innerHTML": _vm._s(_vm.$t('software.product_title3'))
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "platform_info"
  }, [_vm._v(_vm._s(_vm.$t('software.product_vison3')))]), _vm._v(" "), _c('p', {
    staticClass: "platform_info",
    staticStyle: {
      "margin-bottom": "0.35rem"
    }
  }, [_vm._v(_vm._s(_vm.$t('software.product_date3')))])]), _vm._v(" "), _c('li', [_vm._m(1), _vm._v(" "), _c('h3', {
    staticClass: "platform_name",
    domProps: {
      "innerHTML": _vm._s(_vm.$t('software.product_title4'))
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "platform_info"
  }, [_vm._v(_vm._s(_vm.$t('software.product_vison4')))]), _vm._v(" "), _c('p', {
    staticClass: "platform_info",
    staticStyle: {
      "margin-bottom": "0.35rem"
    }
  }, [_vm._v(_vm._s(_vm.$t('software.product_date4')))])]), _vm._v(" "), _c('li', [_vm._m(2), _vm._v(" "), _c('h3', {
    staticClass: "platform_name",
    domProps: {
      "innerHTML": _vm._s(_vm.$t('software.product_title5'))
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "platform_info"
  }, [_vm._v(_vm._s(_vm.$t('software.product_vison5')))]), _vm._v(" "), _c('p', {
    staticClass: "platform_info",
    staticStyle: {
      "margin-bottom": "0.35rem"
    }
  }, [_vm._v(_vm._s(_vm.$t('software.product_date5')))])]), _vm._v(" "), _c('li', [_vm._m(3), _vm._v(" "), _c('h3', {
    staticClass: "platform_name",
    domProps: {
      "innerHTML": _vm._s(_vm.$t('software.product_title6'))
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "platform_info"
  }, [_vm._v(_vm._s(_vm.$t('software.product_vison6')))]), _vm._v(" "), _c('p', {
    staticClass: "platform_info",
    staticStyle: {
      "margin-bottom": "0.35rem"
    }
  }, [_vm._v(_vm._s(_vm.$t('software.product_date6')))])])]), _vm._v(" "), _c('h3', {
    staticClass: "download_item_title",
    attrs: {
      "id": "anchor2"
    }
  }, [_vm._v(_vm._s(_vm.$t('software.introduction_title3')))]), _vm._v(" "), _c('h4', {
    staticClass: "download_item_title2"
  }, [_vm._v(_vm._s(_vm.$t('software.introduction_title4')))]), _vm._v(" "), _c('ul', {
    staticClass: "download_platforms clearfix platform_pic",
    staticStyle: {
      "border-bottom": "none"
    }
  }, [_c('li', [_c('div', {
    staticClass: "pic_box"
  }, [_c('div', {
    staticClass: "pic_mask2"
  }, [_c('a', {
    staticClass: "button3",
    attrs: {
      "href": "https://www.vrviu.com/static/download/sdk/LightEncoder_V1.1.zip"
    }
  }, [_vm._v(_vm._s(_vm.$t('software.download')))])]), _vm._v(" "), _c('img', {
    attrs: {
      "src": require("../assets/images/software/icon_Window@2x.png"),
      "alt": ""
    }
  })]), _vm._v(" "), _c('h3', {
    staticClass: "platform_name",
    domProps: {
      "innerHTML": _vm._s(_vm.$t('software.product_title7'))
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "platform_info"
  }, [_vm._v(_vm._s(_vm.$t('software.product_vison7')))]), _vm._v(" "), _c('p', {
    staticClass: "platform_info",
    staticStyle: {
      "margin-bottom": "0.35rem"
    }
  }, [_vm._v(_vm._s(_vm.$t('software.product_date7')))])]), _vm._v(" "), _c('li', [_vm._m(4), _vm._v(" "), _c('h3', {
    staticClass: "platform_name",
    domProps: {
      "innerHTML": _vm._s(_vm.$t('software.product_title8'))
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "platform_info"
  }, [_vm._v(_vm._s(_vm.$t('software.product_vison8')))]), _vm._v(" "), _c('p', {
    staticClass: "platform_info",
    staticStyle: {
      "margin-bottom": "0.35rem"
    }
  }, [_vm._v(_vm._s(_vm.$t('software.product_date8')))])])]), _vm._v(" "), _c('div', {
    staticClass: "center",
    staticStyle: {
      "border-bottom": "1px solid #eee",
      "padding-bottom": "0.7rem"
    }
  }, [_c('p', {
    staticClass: "platform_info",
    staticStyle: {
      "line-height": "1.6em"
    },
    domProps: {
      "innerHTML": _vm._s(_vm.$t('software.introduction_text'))
    }
  }), _vm._v(" "), _c('a', {
    staticClass: "button_default button_default2",
    attrs: {
      "href": "javascript:void(0)"
    },
    on: {
      "click": function($event) {
        _vm.showDialog()
      }
    }
  }, [_vm._v(_vm._s(_vm.$t('product.text45')))])]), _vm._v(" "), _c('h3', {
    staticClass: "download_item_title",
    attrs: {
      "id": "anchor3"
    }
  }, [_vm._v(_vm._s(_vm.$t('software.introduction_title5')))]), _vm._v(" "), _c('h4', {
    staticClass: "download_item_title2"
  }, [_vm._v(_vm._s(_vm.$t('software.introduction_title6')))]), _vm._v(" "), _c('ul', {
    staticClass: "download_platforms clearfix platform_pic"
  }, [_c('li', [_c('div', {
    staticClass: "pic_box"
  }, [_c('div', {
    staticClass: "pic_mask2"
  }, [_c('a', {
    staticClass: "button3",
    attrs: {
      "href": "https://github.com/vrviu-sdk/VBS",
      "target": "_blank"
    }
  }, [_vm._v(_vm._s(_vm.$t('software.download')))])]), _vm._v(" "), _c('img', {
    attrs: {
      "src": require("../assets/images/software/icon_Window@2x.png"),
      "alt": ""
    }
  })]), _vm._v(" "), _c('h3', {
    staticClass: "platform_name",
    domProps: {
      "innerHTML": _vm._s(_vm.$t('software.product_title9'))
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "platform_info"
  }, [_vm._v(_vm._s(_vm.$t('software.product_vison9')))]), _vm._v(" "), _c('p', {
    staticClass: "platform_info",
    staticStyle: {
      "margin-bottom": "0.35rem"
    }
  }, [_vm._v(_vm._s(_vm.$t('software.product_date9')))])]), _vm._v(" "), _c('li', [_c('div', {
    staticClass: "pic_box"
  }, [_c('div', {
    staticClass: "pic_mask2"
  }, [_c('a', {
    staticClass: "button3",
    attrs: {
      "href": "https://github.com/vrviu-sdk/VBS/blob/master/VBSDemoPlayer.apk",
      "target": "_blank"
    }
  }, [_vm._v(_vm._s(_vm.$t('software.download')))])]), _vm._v(" "), _c('img', {
    attrs: {
      "src": require("../assets/images/software/icon_Android@2x.png"),
      "alt": ""
    }
  })]), _vm._v(" "), _c('h3', {
    staticClass: "platform_name",
    domProps: {
      "innerHTML": _vm._s(_vm.$t('software.product_title10'))
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "platform_info"
  }, [_vm._v(_vm._s(_vm.$t('software.product_vison10')))]), _vm._v(" "), _c('p', {
    staticClass: "platform_info",
    staticStyle: {
      "margin-bottom": "0.35rem"
    }
  }, [_vm._v(_vm._s(_vm.$t('software.product_date10')))])])])])])]), _vm._v(" "), _c('Footerline')], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "pic_box"
  }, [_c('div', {
    staticClass: "pic_mask2"
  }, [_c('img', {
    attrs: {
      "src": require("../assets/images/software/mini_program.jpg"),
      "alt": ""
    }
  })]), _vm._v(" "), _c('img', {
    attrs: {
      "src": require("../assets/images/software/icon_xiao@2x.png"),
      "alt": ""
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "pic_box"
  }, [_c('img', {
    attrs: {
      "src": require("../assets/images/software/icon_vive@2x.png"),
      "alt": ""
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "pic_box"
  }, [_c('img', {
    attrs: {
      "src": require("../assets/images/software/icon_oculus@2x.png"),
      "alt": ""
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "pic_box"
  }, [_c('img', {
    attrs: {
      "src": require("../assets/images/software/icon_MIVR@2x.png"),
      "alt": ""
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "pic_box"
  }, [_c('img', {
    attrs: {
      "src": require("../assets/images/software/icon_Linux@2x.png"),
      "alt": ""
    }
  })])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-37afaeaf"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/software.vue
// module id = 90
// module chunks = 0